var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBisalloy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 32,
    viewBox: "0 0 150 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1581_5289",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 150,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150 0H0V31.2252H150V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1581_5289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.3262 25.9032V5.54736H47.2246C50.778 5.54736 53.1094 7.44467 53.1094 10.9981C53.1094 14.5515 50.8423 15.4198 50.2313 15.5324C51.389 15.7092 54.0259 16.883 54.0259 20.5651C54.0259 24.2471 51.5819 25.9032 47.8999 25.9032H35.3262ZM40.3589 9.7118V13.5707H45.8739C47.2246 13.5707 47.8999 12.9919 47.8999 11.6413C47.8999 10.2906 47.2246 9.7118 45.8739 9.7118H40.3589ZM40.3589 17.7512V21.7388H46.7904C48.0767 21.7388 48.752 21.0957 48.752 19.745C48.752 18.3944 48.0767 17.7512 46.7904 17.7512H40.3589Z",
    fill: "#243444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.791 5.54736H61.7594V9.4063H56.791V5.54736ZM56.791 10.9499H61.7594V25.9032H56.791V10.9338V10.9499Z",
    fill: "#243444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.332 25.903V22.221H72.484C73.095 22.221 73.4648 21.8512 73.4648 21.2402C73.4648 20.6292 73.095 20.2594 72.484 20.2594H69.1075C66.165 20.2594 64.4446 18.5389 64.4446 15.5965C64.4446 12.654 66.165 10.9336 69.1075 10.9336H77.565V14.6157H70.4581C69.8471 14.6157 69.4773 14.9855 69.4773 15.5965C69.4773 16.2075 69.8471 16.5773 70.4581 16.5773H73.8347C76.7771 16.5773 78.4975 18.2977 78.4975 21.2402C78.4975 24.1826 76.7771 25.903 73.8347 25.903H64.332Z",
    fill: "#243444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1231 25.9031C82.052 25.9031 80.3477 24.1826 80.3477 21.1276C80.3477 18.0727 82.0681 16.3361 85.1231 16.3361H90.7668V16.1593C90.7668 15.0498 90.3326 14.6318 89.2393 14.6318H81.3928V10.9497H89.4805C93.8378 10.9497 95.7352 12.847 95.7352 17.2044V25.9192H85.1231V25.9031ZM90.8311 19.9539H86.538C85.7984 19.9539 85.3803 20.388 85.3803 21.1276C85.3803 21.8673 85.8145 22.2853 86.538 22.2853H90.8311V19.9539Z",
    fill: "#243444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.838 5.54736H98.8691V25.9032H103.838V5.54736Z",
    fill: "#243444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.101 5.54736H107.133V25.9032H112.101V5.54736Z",
    fill: "#243444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.324 26.241C117.986 26.241 114.674 24.006 114.674 18.4266C114.674 12.8473 117.986 10.6123 123.324 10.6123C128.662 10.6123 131.975 12.8473 131.975 18.4266C131.975 24.006 128.662 26.241 123.324 26.241ZM126.942 18.4266C126.942 15.7254 125.768 14.3748 123.324 14.3748C120.88 14.3748 119.707 15.7254 119.707 18.4266C119.707 21.1279 120.864 22.4785 123.324 22.4785C125.784 22.4785 126.942 21.1279 126.942 18.4266Z",
    fill: "#243444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.816 30.8071L138.842 25.903L132.828 10.9336H137.796L141.479 20.6292L145.161 10.9336H150L142.09 30.8071H136.816Z",
    fill: "#243444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 14.2137V0H22.623C26.4659 0 29.5691 3.11931 29.5691 6.96216C29.5691 10.805 26.4498 14.2137 22.6069 14.2137H0Z",
    fill: "#005897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 31.225V17.0112H22.623C26.4659 17.0112 29.5852 20.1305 29.5852 23.9734C29.5852 27.8162 26.4659 31.225 22.623 31.225H0Z",
    fill: "#ED1C24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBisalloy);
export default __webpack_public_path__ + "static/media/bisalloy.684452191f768961859923c2f7d3cbc0.svg";
export { ForwardRef as ReactComponent };